import {Country} from '@/types/Country';

export const TEXT = {
  TITLE: {id: 'home.country.title', defaultMessage: 'Select your country'},
  SUBTITLE: {id: 'home.country.subtitle', defaultMessage: 'Your Lookiero experience starts here'},
  SELECT_TEXT: {id: 'home.country.placeholder', defaultMessage: 'Select your country'},
} as const;

export const TEXT_COUNTRY: Record<Country, {id: string; defaultMessage: string}> = {
  [Country.GB]: {id: 'home.country.uk', defaultMessage: 'United Kingdom'},
  [Country.FR]: {id: 'home.country.france', defaultMessage: 'France'},
  [Country.ES]: {id: 'home.country.spain', defaultMessage: 'Spain'},
  [Country.PT]: {id: 'home.country.portugal', defaultMessage: 'Portugal'},
  [Country.BE]: {id: 'home.country.belgium', defaultMessage: 'Belgium'},
  [Country.LU]: {id: 'home.country.luxembourg', defaultMessage: 'Luxembourg'},
  [Country.IT]: {id: 'home.country.italy', defaultMessage: 'Italy'},
  [Country.DE]: {id: 'home.country.germany', defaultMessage: 'Germany'},
  [Country.AT]: {id: 'home.country.austria', defaultMessage: 'Austria'},
  [Country.NL]: {id: 'home.country.netherlands', defaultMessage: 'Netherlands'},
  [Country.SE]: {id: 'home.country.sweden', defaultMessage: 'Sweden'},
  [Country.CH]: {id: 'home.country.switzerland', defaultMessage: 'Switzerland'},
};
